/* global Homie */
import LoaderPopup from '../../shared/libs/LoaderPopup';
import axios from 'axios';

export default {
  template: '#onboarding-presentation',
  props: [],
  data() {
    return {
      buttonMessage: window.innerWidth < 768 ? 'Comenzar' : 'Registrar una propiedad',
      resource: {
        home: {
          owner_id: Homie.user.owner ? Homie.user.owner._id['$oid'] : false
        }
      }
    }
  },
  mounted(){
    $('html, body').animate({scrollTop: 0}, 250);
  },
  computed: {},
  methods: {
    startOnboarding() {
      LoaderPopup.show();
      axios.post('/homes', this.$data.resource)
      .then(response => {
        LoaderPopup.hide();
        window.location.href = `/homes/${response.data.id}/edit/`
      })
    },
  }
}
